export const getMoutereHillsData = () => ({
  name: "Moutere Hills",
  region: "Nelson",
  country: "Nouvelle-Zélande",
  description: "Moutere Hills est une sous-région viticole de Nelson, spécialisée dans les vins aromatiques et les blancs élégants. Les sols argileux et le climat maritime favorisent la production de vins complexes et expressifs.",
  type: "subregion",
  area: "500 ha",
  production: "0.04 million hectolitres",
  climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
  soil: "Sols argileux, bonne rétention d'eau, faible fertilité",
  characteristics: {
    climate: "Climat maritime avec influences océaniques, étés chauds et hivers doux",
    soil: "Sols argileux, bonne rétention d'eau, faible fertilité",
    viticulture: "Viticulture durable, rendements contrôlés, qualité privilégiée"
  },
  wineStyles: {
    white: "Sauvignon Blanc aromatique, Chardonnay élégant, Pinot Gris texturé",
    red: "Pinot Noir fruité, tanins fins",
    rosé: "Rosés délicats et fruités"
  },
  history: "Moutere Hills s'est imposée dans les années 1990 comme une zone viticole de référence à Nelson, avec une attention particulière à la qualité et à l'expression du terroir.",
  foodPairing: "Fruits de mer, poissons, fromages affinés, plats d'été",
  grapeVarieties: [
    { name: "Sauvignon Blanc", percentage: "35%", description: "Vins aromatiques, acidité vive" },
    { name: "Chardonnay", percentage: "30%", description: "Vins élégants, notes de fruits blancs" },
    { name: "Pinot Noir", percentage: "20%", description: "Vins rouges fruités, tanins fins" },
    { name: "Pinot Gris", percentage: "10%", description: "Vins blancs texturés, aromatiques" },
    { name: "Autres", percentage: "5%", description: "Riesling, Gewürztraminer, expérimentaux" }
  ],
  statistics: {
    totalArea: "500 ha",
    production: "0.04 million hectolitres",
    wineries: "12+ domaines",
    exportPercentage: "30%"
  },
  viticulture: "La viticulture à Moutere Hills privilégie la durabilité et la qualité. Les rendements sont limités pour préserver l'intensité aromatique. L'irrigation est utilisée avec parcimonie.",
  winemaking: "La vinification se fait en cuves inox pour les blancs et en fûts pour les rouges. Les styles varient selon les producteurs.",
  terroir: "Moutere Hills est caractérisée par ses sols argileux et son climat maritime, permettant une grande diversité de styles et de cépages.",
  mapAreas: [
    { region: "Moutere Hills", x: 173.0, y: -41.3, color: "#4B164C", size: 4 }
  ]
}); 